import { useTranslation } from "react-i18next";
/**
 * ModuleNotLicensed (P270.4) -- placeholder shown when a module isn't on
 * the deployment's license. A calm "padlock" panel, not an error toast,
 * differentiating an upgrade ask from a generic failure.
 *
 * Rendered by a route/section guard when `isModuleLicensed(status, module)`
 * is false (the SPA-side mirror of the backend deployment gate). Hardcoded
 * English to match the sibling shared/ surfaces.
 */
export function ModuleNotLicensed({ module }: { module: string }) {
  const { t } = useTranslation();
  return (
    <div
      data-testid="module-not-licensed"
      data-module={module}
      className="mx-auto max-w-lg px-6 py-16 text-center"
    >
      <div className="mb-3 text-3xl" aria-hidden>
        🔒
      </div>
      <h1 className="font-display text-xl text-slate-900">
        {t("screens.moduleNotLicensed.the")} {module}{" "}
        {t("screens.moduleNotLicensed.moduleIsnTEnabled")}
      </h1>
      <p className="mt-2 text-sm text-slate-500">
        {t("screens.moduleNotLicensed.thisDeploymentSLicenseDoesnTInclude")} {module}{" "}
        {t("screens.moduleNotLicensed.moduleContactYourAccountTeamToUpgrade")}
      </p>
    </div>
  );
}
